module.exports = __webpack_public_path__ + "assets/a-18-xiguan.f05a2c27.svg";